import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormGroup, FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Event as StoreEvent } from '../../../types';
@Component({
  selector: 'app-link-form-field',
  standalone: true,
  imports: [
    MatRadioModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    CommonModule,
    MatTooltipModule,
  ],
  templateUrl: './link-form-field.component.html',
  styleUrl: './link-form-field.component.css',
})
export class LinkFormFieldComponent implements OnInit {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() className: string = '';
  @Input() formGroup!: FormGroup;
  @Input() controlName: string = '';
  @Input() enablePasteButton: boolean = false;
  @Input() event: StoreEvent | null = null;

  get control(): FormControl {
    return this.formGroup.get(this.controlName) as FormControl;
  }

  useEventUrl: boolean = false;

  ngOnInit(): void {
    if (this.control && this.control.value == '{{event URL}}') {
      this.useEventUrl = true;
    }
  }

  onUseEventUrlChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.useEventUrl = target.checked;
    if (this.useEventUrl) {
      this.control.setValue('{{event URL}}');
    } else {
      this.control.setValue('');
    }
  }

  onPasteButtonClick() {
    navigator.clipboard
      .readText()
      .then((text) => {
        this.control.setValue(this.control.value + text);
      })
      .catch((err) => {
        console.error('Failed to read clipboard contents: ', err);
      });
  }
}
